import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TargetIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M22,11H20.94A9,9,0,0,0,13,3.06V2a1,1,0,0,0-2,0V3.06A9,9,0,0,0,3.06,11H2a1,1,0,0,0,0,2H3.06A9,9,0,0,0,11,20.94V22a1,1,0,0,0,2,0V20.94A9,9,0,0,0,20.94,13H22a1,1,0,0,0,0-2ZM12,19a7,7,0,1,1,7-7A7,7,0,0,1,12,19Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M12,8a4,4,0,1,0,4,4A4,4,0,0,0,12,8Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,12,14Z"
  })]
}), 'TargetIcon');